module.exports = __webpack_public_path__ + "media/application/images/demo/wall2-bdb1ee7fd2b1d680737801b7e6c9257a.jpg";